// extracted by mini-css-extract-plugin
export default {"page":"Ph-z","cartModal":"Qh-z","checkout":"Rh-z","placeholder":"Sh-z","account":"Th-z"};